import React from 'react';
import { usePermission } from '@/hooks/usePermission';

interface PermissionGuardProps {
  module: string;
  action: string;
  children: React.ReactNode;
  fallback?: React.ReactNode;
}

export function PermissionGuard({
  module,
  action,
  children,
  fallback = null
}: PermissionGuardProps) {
  const hasPermission = usePermission(module, action);

  if (!hasPermission) {
    return fallback ? <>{fallback}</> : null;
  }

  return <>{children}</>;
}

interface ConditionalRenderProps {
  condition: boolean;
  children: React.ReactNode;
  fallback?: React.ReactNode;
}

export function ConditionalRender({ condition, children, fallback = null }: ConditionalRenderProps) {
  return condition ? <>{children}</> : fallback ? <>{fallback}</> : null;
}

interface IfProps {
  condition: boolean;
  children: React.ReactNode;
}

export function If({ condition, children }: IfProps) {
  return condition ? <>{children}</> : null;
}
